
import EmployeeAvatar from '@/components/employee/EmployeeAvatar.vue';
import { AvatarSizes } from '@/lib/enum/AvatarSizes';
import { Icon } from '@/lib/enum/Icon';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import { PropType } from 'vue';
import VueI18n from 'vue-i18n';
import { Employee } from '../../../api/v1';
import { fullName } from '../../lib/employee/employeeFunctions';
import EmployeeListItem from '../employee/EmployeeListItem.vue';
import TranslateResult = VueI18n.TranslateResult;

export default {
  name: 'EmployeeAutoComplete',

  components: {
    EmployeeAvatar,
    EmployeeListItem,
  },

  inheritAttrs: false,

  props: {
    value: {
      type: [Number, String, Array],
      default: null,
    },

    additionalFilter: {
      type: Function as PropType<(e: Employee) => boolean>,
      default: () => true,
    },

    labelText: {
      type: [String, TranslateResult],
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    required: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    height: {
      type: [Number, String],
      default: 56,
    },

    multiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      AvatarSizes,
      Icon,
      focused: false,
      search: '',
      employees: realtimeQuery(Entity.Employee).fetch(),
    };
  },

  computed: {
    filteredEmployees() {
      return this.employees.data.filter(this.additionalFilter);
    },

    noData() {
      if (this.search && !this.filteredEmployees.length) {
        return this.$t('noData.employeeSearch');
      }
      return this.$t('noData.noEmployees');
    },
  },

  methods: {
    fullName,

    handleInput(event) {
      this.$emit('input', event);
      document.activeElement.blur();
    },
  },
};
